import { betActions } from '../../../store/slices/bets/slice';
import type { IBetSpotValue, AcceptedBet, BetType } from '../../../store/slices/bets/types';
import { ChipTypes } from '../../../store/slices/chips/types';
import type { GameCommunicationMessageType } from '../types';
import { MessageName } from '../types';

import { BaseBetGameCommunicationProcessor } from './BaseBetGameCommunicationProcessor';

interface BetsMessage extends GameCommunicationMessageType {
  bet: {
    amount: string;
    betcode: string;
    bettype?: string;
    nc?: string;
  }[];
}

// This processor is used to restore placed bets after page refresh
export class CoreBetsGameCommunicationProcessor extends BaseBetGameCommunicationProcessor {
  public messageName = MessageName.Bets;

  /** gets invoked when user has placed a bet and reconnects to the game */
  public process(message: BetsMessage): void {
    const tableId = this.store.getState().config.session?.tableId || '';
    const restoredBet: BetType = {
      betSpots: {},
    };

    const acceptedBets: AcceptedBet[] = message.bet.map((bet) => {
      const acceptedBet: AcceptedBet = {
        amount: Number(bet.amount),
        betCode: Number(bet.betcode),
        errorCode: 0,
      };
      const betObj: IBetSpotValue = { value: acceptedBet.amount };
      acceptedBet.type = betObj.type = (bet.bettype as ChipTypes) || ChipTypes.CasinoChip;
      if (bet.bettype === ChipTypes.FreeChip) {
        acceptedBet.count = betObj.count = Number(bet.nc);
      }
      restoredBet.betSpots[bet.betcode] = betObj;
      return acceptedBet;
    });

    this.store.dispatch(betActions.setAcceptedBets(acceptedBets));
    this.store.dispatch(betActions.updateBetStackHead(restoredBet));
    this.store.dispatch(betActions.saveLastBets({ tableId }));
  }
}
